import React from 'react'

import { PackageIcon } from 'lucide-react'
import { observer } from 'mobx-react'

import { useConsumedSearchParamState } from '~/client/src/shared/hooks/useConsumedSearchParamState'
import Localization from '~/client/src/shared/localization/LocalizationManager'

import { SETUP_TAB_QUERY_KEY } from '../../ProjectSetUpPages'
import MaterialResourcesControls from './MaterialResourcesControls/MaterialResourcesControls'
import MaterialResourcesForms from './MaterialResourcesForms/MaterialResourcesForms'
import MaterialResourcesObjects from './MaterialResourcesObjects/MaterialResourcesObjects'
import MaterialResourcesProperties from './MaterialResourcesProperties/MaterialResourcesProperties'
import MaterialResourcesSetupTabs, {
  MaterialResourcesTab,
} from './MaterialResourcesSetupTabs'

function MaterialResourcesSetup() {
  // ?tab= deep-links into a sub-tab (from the resource picker) and is cleared
  // once consumed so a later refresh keeps the user's last selected tab.
  const [activeTab, setActiveTab] = useConsumedSearchParamState(
    SETUP_TAB_QUERY_KEY,
    Object.values(MaterialResourcesTab),
    MaterialResourcesTab.Objects,
  )

  const renderTabContent = () => {
    switch (activeTab) {
      case MaterialResourcesTab.Objects:
        return <MaterialResourcesObjects />
      case MaterialResourcesTab.Controls:
        return <MaterialResourcesControls />
      case MaterialResourcesTab.Forms:
        return <MaterialResourcesForms />
      case MaterialResourcesTab.Properties:
        return <MaterialResourcesProperties />
      default:
        return null
    }
  }

  return (
    <div className="tw:flex tw:flex-col tw:h-full">
      <div className="tw:flex tw:items-center tw:py-1.5 tw:my-2.5">
        <PackageIcon className="tw:grow-0 tw:mr-[5px]" />
        <span className="tw:text-title-lg tw:font-semibold tw:text-foreground tw:grow-0 tw:whitespace-nowrap">
          {Localization.translator.materials}
        </span>
      </div>
      <MaterialResourcesSetupTabs
        activeTab={activeTab}
        onTabClick={setActiveTab}
      />
      <div className="tw:flex-1 tw:min-h-0">{renderTabContent()}</div>
    </div>
  )
}

export default observer(MaterialResourcesSetup)
